var _g;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
class IconSubtitlesLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconSubtitles",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _g || (_g = _jsxs("g", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        children: [_jsx("path", {
          d: "M320 1221.33c0-32.4 26.266-58.66 58.667-58.66h736.003c32.4 0 58.66 26.26 58.66 58.66 0 32.4-26.26 58.67-58.66 58.67H378.667c-32.401 0-58.667-26.27-58.667-58.67zm1066.67 0c0-32.4 26.26-58.66 58.66-58.66h96c32.4 0 58.67 26.26 58.67 58.66 0 32.4-26.27 58.67-58.67 58.67h-96c-32.4 0-58.66-26.27-58.66-58.67zm-581.337 261.34c-32.4 0-58.666 26.26-58.666 58.66 0 32.4 26.266 58.67 58.666 58.67h735.997c32.4 0 58.67-26.27 58.67-58.67 0-32.4-26.27-58.66-58.67-58.66H805.333zM320 1541.33c0-32.4 26.266-58.66 58.667-58.66h96c32.4 0 58.666 26.26 58.666 58.66 0 32.4-26.266 58.67-58.666 58.67h-96c-32.401 0-58.667-26.27-58.667-58.67z"
        }), _jsx("path", {
          d: "M0 213.333C0 95.513 95.513 0 213.333 0H1706.67C1824.49 0 1920 95.513 1920 213.333V1706.67c0 117.82-95.51 213.33-213.33 213.33H213.333C95.513 1920 0 1824.49 0 1706.67V213.333Zm213.333-96H1706.67c53.02 0 96 42.981 96 96V1706.67c0 53.02-42.98 96-96 96H213.333c-53.019 0-96-42.98-96-96V213.333c0-53.019 42.981-96 96-96Z"
        })]
      }))
    });
  }
}
IconSubtitlesLine.glyphName = 'subtitles';
IconSubtitlesLine.variant = 'Line';
IconSubtitlesLine.displayName = 'IconSubtitlesLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconSubtitlesLine.propTypes = {
  ...SVGIcon.propTypes
};
IconSubtitlesLine.allowedProps = [...SVGIcon.allowedProps];
export default IconSubtitlesLine;
export { IconSubtitlesLine };